export class InformationModel {
  public chapter: string = '';
  public question: string = '';

  public constructor(init?:Partial<InformationModel>) {
    Object.assign(this, init);
  }
}
